import FileManagerActionType from 'actions/fileManager/fileManagerActionType';

const initialState = {
  loading: false,
  allDirectoriesLoading: false,
  directoriesLoading: false,
  baseDirectories: [],
  directories: [],
  fileTypeGroups: [],
  modalVisible: false,
  popoverVisible: false,
  brandId: null,
  filesByPaths: [],
  directoriesEndedStatus: false,
};

const fileManagerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case FileManagerActionType.SAVE_DIRECTORIES:
    return {
      ...state,
      loading: false,
      directories: payload.data,
    };
  case FileManagerActionType.SAVE_BASE_DIRECTORIES:
    return {
      ...state,
      baseDirectories: payload.data,
    };
  case FileManagerActionType.CHANGE_ALL_DIRECTORIES_LOADING_STATE: {
    return {
      ...state,
      allDirectoriesLoading: payload.state,
    };
  }
  case FileManagerActionType.CHANGE_FILE_MANAGER_LOADING_STATE:
    return {
      ...state,
      loading: payload.state,
    };
  case FileManagerActionType.GET_FILE_TYPE_GROUPS_SUCCESS:
    return {
      ...state,
      fileTypeGroups: payload.data,
      loading: false,
    };
  case FileManagerActionType.CHANGE_FILE_MANAGER_MODAL_VISIBILITY:
    return {
      ...state,
      modalVisible: payload.state,
    };
  case FileManagerActionType.CHANGE_FILE_MANAGER_BRAND_ID:
    return {
      ...state,
      brandId: payload.brandId,
    };
  case FileManagerActionType.CHANGE_DIRECTORIES_ENDED_STATUS:
    return {
      ...state,
      directoriesEndedStatus: payload.state,
    };
  case FileManagerActionType.CHANGE_FILE_MANAGER_POPOVER_VISIBILITY:
    return {
      ...state,
      popoverVisible: payload.state,
    };
  case FileManagerActionType.RESET_FILE_MANAGER_STATE:
    return initialState;
  case FileManagerActionType.SAVE_FILES_BY_PATHS:
    return {
      ...state,
      filesByPaths: payload.data,
    };
  case FileManagerActionType.RESET_FILES_BY_PATHS:
    return {
      ...state,
      filesByPaths: [],
    };
  default:
    return state;
  }
};

export default fileManagerReducer;
